import axios from '@/libs/api.request'
// 获取批量信息
export const getBank = (params) => {
  return axios.request({
    url: '/finance/bank',
    method: 'GET',
    params
  })
}
// 获取单个信息
export const getDetails = (id) => {
  return axios.request({
    url: `/finance/bank/${id}`,
    method: 'GET'
  })
}
// 删除单个信息
export const del = (id) => {
  return axios.request({
    url: `/finance/bank/${id}`,
    method: 'DELETE'
  })
}
// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/finance/bank/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  return axios.request({
    url: '/finance/bank',
    method: 'POST',
    data
  })
}
